import { RootState } from '@/src/v2/store';

export const useUserSelector = (state: RootState) => state.user.user;
export const useIsLoggingSelector = (state: RootState) => state.user.isLogging;
export const useChannelSelector = (state: RootState) => state.user.channel;
export const useIsSidebarOpenSelector = (state: RootState) =>
  state.presentation.isSidebarOpen;
export const useToastSelector = (state: RootState) =>
  state.presentation.toastMessage;
export const useMobileMenuSelector = (state: RootState) =>
  state.mobileMenu.menuStatus;
export const useMobileMenuisSearchSelector = (state: RootState) =>
  state.mobileMenu.isSearch;
export const useIsSearchOpenSelector = (state: RootState) =>
  state.presentation.isSearchOpen;
